import React, { Fragment, useCallback } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import { sendEventClick } from 'src/api/tracker';

import SeeAllTile from 'src/components/SeeAllTile';
import Offers from 'src/components/Offers';
import ChosenEmptyListing from 'src/components/EmptyListing/ChosenEmptyListing';
import AgreementMissing from 'src/components/EmptyListing/AgreementMissing';

import { ignoreOffer } from 'src/redux/actions/ignore-offer';
import { toggleOffer } from 'src/redux/actions/toggle-offer';

// eslint-disable-next-line max-statements
const OffersListingContainer = () => {
  const accountURL = useSelector(
    ({ configReducer }) => configReducer.accountURL
  );
  const { offers, hasProfilingAgreement } = useSelector(
    ({ offersReducer }) => ({
      offers: offersReducer.offers,
      hasProfilingAgreement: offersReducer.hasProfilingAgreement,
    }),
    shallowEqual
  );
  const dispatch = useDispatch();

  const toggleFavouriteOffer = useCallback(
    (offerId, isFavourite) => {
      dispatch(toggleOffer({ offerId, isFavourite }));
    },
    [dispatch]
  );

  const ignoreRecommendedOffer = useCallback(
    (offerId) => {
      dispatch(ignoreOffer({ offerId }));
    },
    [dispatch]
  );

  const handleOfferClick = useCallback((index) => {
    sendEventClick(`rec_bestmatch`, index);
  }, []);

  if (!hasProfilingAgreement) {
    return <AgreementMissing />;
  }

  if (offers.length === 0) {
    return <ChosenEmptyListing />;
  }

  const renderSeeAllTile = () => {
    const seeAllTileText = 'Zobacz wszystkie rekomendowane oferty';
    const seeAllTileContentUpperText = 'Zobacz wszystkie';
    const seeAllTileContentLowerText = 'rekomendowane oferty';

    return (
      <SeeAllTile link={accountURL} title={seeAllTileText}>
        <>
          {seeAllTileContentUpperText}
          <br />
          {seeAllTileContentLowerText}
        </>
      </SeeAllTile>
    );
  };

  return (
    <>
      <Offers
        offers={offers}
        remove={ignoreRecommendedOffer}
        toggleFavourite={toggleFavouriteOffer}
        onOfferClick={handleOfferClick}
      />
      {renderSeeAllTile()}
    </>
  );
};

export default OffersListingContainer;
